import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NavController, LoadingController } from '@ionic/angular';

import { Constants } from "../../models/constants"

import { PaymentService } from "../../services/payment-service";
import { Alert } from "../../services/alert";

declare var Stripe: any;

interface AddCardInfo {
  name?: string;
  number?: string;
  cvc?: string;
  expiry?: string;
  zip?: string;
}

@Component({
  selector: 'app-add-payment',
  templateUrl: './add-payment.page.html',
  styleUrls: ['./add-payment.page.scss'],
})
export class AddPaymentPage implements OnInit {

  //
  // Modified from https://github.com/Baadier-Sydow/ionic-stripe/blob/master/src/pages/stripe-java-script/stripe-java-script.ts
  //

  fields: { cardholderName?: string } = {}

  stripe: any;
  card: any;

  constructor(
    public navCtrl: NavController,
    public paymentService: PaymentService,
    public alert: Alert,
    public loadingCtrl: LoadingController,
    private changeRef: ChangeDetectorRef,
  ) {
    if (Constants.DEV_MODE) {
      this.stripe = Stripe(Constants.DEV_STRIPE_KEY);
    } else {
      this.stripe = Stripe(Constants.STRIPE_KEY);
    }
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.setupStripe();
  }

  setupStripe() {
    let elements = this.stripe.elements();
    var style = {
      base: {
        color: '#32325d',
        lineHeight: '24px',
        fontFamily: '"Fira Sans", Arial, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    };

    this.card = elements.create('card', { style: style });

    this.card.mount('#card-element');

    this.card.addEventListener('change', (event: any) => {
      var displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
      this.changeRef.detectChanges()
    });
  }

  submit() {
    let data = {
      name: this.fields.cardholderName
    }

    this.stripe.createToken(this.card, data).then((result: any) => {
      if (result.error) {
        var errorElement = document.getElementById('card-errors');
        errorElement.textContent = result.error.message;
      } else {
        this.createCustomer(result.token)
      }
      this.changeRef.detectChanges()
    });
  }

  private async createCustomer(token: any) {

    let loading = await this.loadingCtrl.create();
    loading.present();

    this.paymentService.createCustomer(

      token,
      this.fields.cardholderName,

      () => {
        loading.dismiss();
        this.navCtrl.pop();
      }, (errorMsg: string) => {
        loading.dismiss();
        this.alert.show('Error', errorMsg, 'Ok');
      });

  }

}
